import CryptoJS from "crypto-js";
var key = CryptoJS.enc.Utf8.parse('#@Ge_Off_erp@@12');
var iv = CryptoJS.enc.Utf8.parse('#@Ge_Off_erp@@00');

// function for AES encryption
export const encrypted = (data) => {
  var encryptedData = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key,
    {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  return encryptedData.toString();
};

// function for AES decryption
export const decrypted = (data) => {
  var decryptedData = CryptoJS.AES.decrypt(data, key,
    {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  return CryptoJS.enc.Utf8.stringify(decryptedData);
};


export function snapToNearestInch(decimalPart) {
  if (decimalPart <= 0.03) return 0.00;
  if (decimalPart <= 0.12) return 0.08;
  if (decimalPart <= 0.20) return 0.17;
  if (decimalPart <= 0.29) return 0.25;
  if (decimalPart <= 0.37) return 0.33;
  if (decimalPart <= 0.46) return 0.42;
  if (decimalPart <= 0.54) return 0.50;
  if (decimalPart <= 0.62) return 0.58;
  if (decimalPart <= 0.70) return 0.67;
  if (decimalPart <= 0.79) return 0.75;
  if (decimalPart <= 0.87) return 0.83;
  if (decimalPart <= 0.95) return 0.92;
  return 1.00;
}

export function applySnapToGridForRolledGoods(quantitySY, rollWidth) {
  if (!rollWidth || rollWidth <= 0) return quantitySY;

  // Convert SY → SF
  const quantitySF = quantitySY * 9;

  // Raw LF
  let rawLF = quantitySF / rollWidth;
  // rawLF = Number(rawLF.toFixed(2))
  // Separate whole feet and decimal
  const wholeFeet = Math.floor(rawLF);

  let decimalPart = rawLF - wholeFeet;

  // Truncate to 2 decimals (NO floating point rounding)
  decimalPart = Math.trunc(decimalPart * 100) / 100;

  // Snap decimal to nearest inch
  const snappedDecimal = snapToNearestInch(decimalPart);

  // Clean LF
  const cleanLF = wholeFeet + snappedDecimal;

  // Convert back LF → SF → SY
  const cleanSF = cleanLF * rollWidth;
  const cleanSY = cleanSF / 9;

  // Truncate to 2 decimals (match C# logic)
  // return Number(cleanSY.toFixed(2));
  return Math.trunc(cleanSY * 100) / 100;
}
